import { MANTY_AUTH, SSO_SUFFIX } from 'business/constants';
import { useSelector } from 'store/hooks';
import { defaultUser } from './CreateMultipleUserReducer';

export const useGetDefaultUser = () => {
    const { authMethods } = useSelector((state) => state.vision.client);
    const ssoMethod = authMethods.find((authMethod) =>
        authMethod.endsWith(SSO_SUFFIX),
    );
    return {
        ...defaultUser,
        authMethods: ssoMethod ? [ssoMethod] : [MANTY_AUTH],
    };
};
